import PresentationAttendeesComponent from './PresentationAttendeesComponent'

export default PresentationAttendeesComponent
